import React from 'react'

const AuthCtx = React.createContext()

export default AuthCtx
